<template>
    <ContentOrLoading>
        <div :class="['table', { 'expanded': abonos.data.length <= 3 }]" v-if="abonos && abonos.data">
            <b-table 
                striped
                hover
                :fields="fields"
                :items="abonos.data"
                :per-page="per_page"
            >
                <template #cell(activo)></template>
                <template #cell(opciones)="{ item, index }">
                    <OpcionesDropdownTableComponent 
                        :lastIndex="abonos.data.length > 3 && index >= abonos.data.length - 3"
                        v-bind:options="[
                            {
                                to: {
                                    name: 'back.abonados.show',
                                    params: { lista_id: item.lista_id, abonado_id: item.id },
                                },
                                label: 'Ver abono',
                            },
                            { type: 'action', action:() => abrirEnNuevaPestana(item.url_imprimir), label: 'Imprimir'},
                        ]"
                    /> 
                </template>
            </b-table>
        </div>
        <div class="text-right" v-if="abonos && abonos.meta">
            <b-pagination
                v-model="abonos.meta.current_page"
                :per-page="abonos.meta.per_page"
            />
        </div>
    </ContentOrLoading>
</template>

<script>
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

    export default {
        props: ['lista_id', 'user_id'],
        data() {
            return {
                abonos: null,
                per_page: 10,
                current_page: 1,
                fields: [
                    { key: 'activo', label: '', class: 'text-center', tdClass: this.estaRenovadoCellClass },
                    { key: 'n_abonado', label: 'Número de Abonado', class: 'text-center' },
                    { key: 'nombre', label: 'Nombre', class: 'text-center' },
                    { key: 'apellidos', label: 'Apellidos', class: 'text-center' },
                    { key: 'dni', label: 'DNI', class: 'text-center' },
                    { key: 'email', label: 'Email', class: 'text-center' },
                    { key: 'opciones', label: 'Opciones', class: 'text-center' }
                ]
            }
        },
        methods: {
            getAbonos() {
                this.loading = true;

                const params = {
                    filters: {
                        lista_id: this.lista_id,
                        per_page: this.per_page
                    },
                    user_id: this.user_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.usuarios.abonos'), params).then(res => {
                    this.abonos = res.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            estaRenovadoCellClass(value, key, item) {
                switch (value) {
                    case 1:
                        return 'bg-green';

                    case 2:
                        return 'bg-info';

                    default:
                        return 'bg-red';
                }
            },
            abrirEnNuevaPestana(url) {
                window.open(url, '_blank');
            }
        },
        created() {
            this.getAbonos();
        },
        components: {
            OpcionesDropdownTableComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>